import { createAction } from '@reduxjs/toolkit';

export const analyticsBiometricRegistrationFailedModalViewed = createAction(
    'ANALYTICS::BIOMETRIC_REGISTRATION_FAILED_MODAL::VIEWED',
);
